import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  bold: {
    display: 'block',
    fontWeight: 800,
    marginBottom: 16,
  },
}))

function GoalReviewed({ review }) {
  const classes = useStyles();

  if(!review){
    return null;
  }

  return (
    <>
      <span className={classes.bold}>After further review, we have a GOOD GOAL.</span>
    </>
  )
}

export default GoalReviewed;
